import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { BlockCta } from '../../../components';
import { BlockCTA } from '../../../types/uncinc_profile/blocks';

export interface CtaBlockProps {
  entity: ImmutableEntity<BlockCTA>;
}

const CTABlock: React.FC<CtaBlockProps> = (props) => {
  const { entity } = props;

  const ctaBlockEntity = entity.toJS();

  const info = ctaBlockEntity.info[0].value;
  const body = ctaBlockEntity.body[0]?.processed;
  const linkTitle = ctaBlockEntity.field_link[0].title;
  const linkUri =
    ctaBlockEntity.field_link[0].alias ||
    ctaBlockEntity.field_link[0].uri;

  const secondaryLinkTitle = ctaBlockEntity.field_link_secondary?.[0]?.title;
  const secondaryLinkUri =
    ctaBlockEntity.field_link_secondary?.[0]?.alias ||
    ctaBlockEntity.field_link_secondary?.[0]?.uri;

  return (
    <div className="CtaBlock">
      <BlockCta
        title={info}
        text={body}
        button={{
          text: linkTitle,
          link: linkUri,
        }}
        {...(secondaryLinkTitle && secondaryLinkUri ? {
          buttonSecondary: {
            text: secondaryLinkTitle,
            link: secondaryLinkUri,
          },
        } : {})}
      />
    </div>
  );
};

export default CTABlock;
